import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "reactstrap";

import { Link, useParams } from "react-router-dom";

import AtsImg from "../../assets/images/ats-logo2.png";

//i18n
import { withTranslation } from "react-i18next";
import { FileUpload } from 'primereact/fileupload';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import { InputText, InputTextarea } from 'primereact';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';

import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { TriStateCheckbox } from "primereact/tristatecheckbox"
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";

import Thankyou from "../../assets/images/thank-you.jpg"

// Small form 
import { Card } from 'primereact/card';
// import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import axios from "axios";
import { getBase64, simpleAlert, triggerAlert } from "utils/CommonFunctions";
import { ProgressSpinner } from "primereact/progressspinner";
import moment from "moment";
// import { Grid } from 'primereact/grid';
import { data } from './../Reports/TimeToHire';




const CandidateForm = () => {

  //lokesh
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [street1, setStreet1] = useState('');
  const [street2, setStreet2] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [address, setAddress] = useState('');
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [categoryNodes, setCategoryNodes] = useState([]);
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null);
  const [groupNodes, setGroupNodes] = useState([]);
  const [selectedGroupNode, setSelectedGroupNode] = useState(null);

  const [tempStreet1, setTempStreet1] = useState('');
const [tempStreet2, setTempStreet2] = useState('');
const [tempPostalCode, setTempPostalCode] = useState('');
const [tempSelectedCountry, setTempSelectedCountry] = useState(null);
const [tempSelectedState, setTempSelectedState] = useState(null);
const [tempSelectedCity, setTempSelectedCity] = useState(null);
const [tempSelectedLabel, setTempSelectedLabel] = useState(null);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/api/v1/get-all-categories/');
        if (response.data && response.data.results) {
          const treeData = transformCategoriesToTree(response.data.results);
          setCategoryNodes(treeData);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    const fetchGroups = async () => {
      try {
        const response = await axios.get('/api/v1/get-all-groups/');
        if (response.data && response.data.results) {
          const groupTree = transformGroupsToTree(response.data.results);
          setGroupNodes(groupTree);
        }
      } catch (error) {
        console.error('Error fetching groups:', error);
      }
    };

    fetchCategories();
    fetchGroups();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get('/api/v1/get-all-countries/');
        setCountries(response.data.results);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

useEffect(() => {
  if (selectedCountry && selectedCountry.country_id) {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`/api/v1/get-all-states/?country_id=${selectedCountry.country_id}`);
        setStates(response.data.results);
      } catch (error) {
        setStates([]);
        console.error('Error fetching states:', error);
      }
    };
    fetchStates();
  }
}, [selectedCountry]);

useEffect(() => {
  if (selectedState && selectedState.state_id) {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`/api/v1/get-all-cities/?state_id=${selectedState.state_id}`);
        setCities(response.data.results);
      } catch (error) {
        setCities([]);
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }
}, [selectedState]);
useEffect(() => {
  if (tempSelectedCountry && tempSelectedCountry.country_id) {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`/api/v1/get-all-states/?country_id=${tempSelectedCountry.country_id}`);
        setStates(response.data.results);
      } catch (error) {
        setStates([]);
        console.error('Error fetching states:', error);
      }
    };
    fetchStates();
  }
}, [tempSelectedCountry]);

useEffect(() => {
  if (tempSelectedState && tempSelectedState.state_id) {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`/api/v1/get-all-cities/?state_id=${tempSelectedState.state_id}`);
        setCities(response.data.results);
      } catch (error) {
        setCities([]);
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }
}, [tempSelectedState]);

  useEffect(() => {
    if (selectedState) {
      const fetchCities = async () => {
        try {
          const response = await axios.get(`/api/v1/get-all-cities/?state_id=${selectedState.state_id}`);
          setCities(response.data.results);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
      };

      fetchCities();
    }
  }, [tempSelectedState]);

  const updateAddress = () => {
    const updatedAddress = [street1, street2, tempSelectedCity?.name, tempSelectedState?.name, tempSelectedCountry?.name, postalCode].filter(Boolean).join(', ');
    setAddress(updatedAddress);
  };
  const transformCategoriesToTree = (categories) => {
    const buildTree = (category) => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories ? category.subcategories.map(buildTree) : []
    });
    return categories.map(buildTree);
  };

  const transformGroupsToTree = (groups) => {
    const buildTree = (group) => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups.map(buildTree) : []
    });
    return groups.map(buildTree);
  };



  // State variables for form fields
  const [isUploading, setIsUploading] = useState(false);
  const [submittedData, setSubmittedData] = useState({});
  const [visible, setVisible] = useState(false);
  const [basicfirst, setBasicfirst] = useState('');
  const [basicmiddle, setBasicmiddle] = useState('');
  const [basiclast, setBasiclast] = useState('');
  const [basictittle, setBasictittle] = useState('');
  const [basicimp, setBasicimp] = useState('');
  const [company, setCompany] = useState('');
  const [jobtitle, setJobtitle] = useState('');
  const [totalExperience, setTotalExperience] = useState(null);
  const [email, setEmail] = useState('');
  const [selectedLabel1, setSelectedLabel1] = useState(null);
  const [primarySkills, setPrimarySkills] = useState([]);
  const [secondarySkills, setSecondarySkills] = useState([]);
  const [otherSkills, setOtherSkills] = useState([]);
  const [currentSalary, setCurrentSalary] = useState(null);
  const [expectedSalary, setExpectedSalary] = useState(null);
  const [dob, setDob] = useState(null);
  const [dateAvalibility, setDateAvalibility] = useState(null);
  const [workExperiences, setWorkExperiences] = useState([]);
  const [educationDetails, setEducationDetails] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [thankyou, setThankyou] = useState(false);
  const [Upload, setUpload] = useState(false);
  const [source, setSource] = useState('');
  const [phone, setPhone] = useState('');
  const [referredBy, setReferredBy] = useState('');
  // const [errors, setErrors] = useState({
  //   basicfirst: '',
  //   email: '',
  //   phone: '',
  //   source: '',
  //   referredBy: '',
  // });

  // const [selectedCity, setSelectedCity] = useState(null)
  // const cities = [
  //   { name: "Work From Office", code: "emp1" },
  //   { name: "Work From Remote", code: "emp2" },
  //   { name: "Work From Home", code: "emp3" },
  //   { name: "Freelancer", code: "emp4" },

  // ]

  const [selectedStatus, setSelectedStatus] = useState('')
  const [dateFromTo, setDateFromTo] = useState(null);


  const [fullname, setFullname] = useState(null);
  const [fullNameDialogVisible, setFullNameDialogVisible] = useState(false);

  // const [company, setCompany] = useState(null);
  // const [jobtitle, setJobtitle] = useState(null);
  // const [email, setEmail] = useState(null);
  // const [totalExperience, setTotalExperience] = useState(null);
  // const [address, setAddress] = useState('');

  // const [currentSalary, setCurrentSalary] = useState(null);
  // const [expectedSalary, setExpectedSalary] = useState(null);




  // education

  // const [educationDetails, setEducationDetails] = useState([]);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [newEducation, setNewEducation] = useState({
    degree: '',
    institution: '',
    year: '',
    endYear: '',
    endMonth: '',
    grade: '',
  });

  // Add new education details to the table
  const handleAddEducation = () => {
    if (
      newEducation.degree.trim() &&
      newEducation.institution.trim() &&
      newEducation.year.trim() &&
      newEducation.grade.trim()
    ) {
      setEducationDetails([...educationDetails, { ...newEducation }]);
      setNewEducation({ degree: '', institution: '', year: '', grade: '' });
      setIsDialogVisible(false);
    } else {
      alert("Please fill all fields.");
    }
  };

  const handleSave1 = () => {
    if (editIndex !== null) {
      // Update existing record
      const updatedExperiences = [...educationDetails];
      updatedExperiences[editIndex] = newEducation;
      setEducationDetails(updatedExperiences);
      setEditIndex(null);
    } else {
      // Add new record
      setEducationDetails([...educationDetails, newEducation]);
    }
    setNewEducation({
      degree: " ",
      website: " ",
      jobTitle: " ",
      fromDate: null,
      toDate: null,
      description: " ",
    });
    setIsDialogVisible(false);
  };

  const handleSavedocument = () => {
    if (documentvalu.selectedDocument && documentvalu.subject && documentvalu.file) {
      // Add new document to the documents array
      setDocuments([...documents, { ...documentvalu }]);
      setdocumentvalu({
        selectedDocument: "",
        subject: "",
        file: null,
      });
      setDisplayDialog(false);
    } else {
      simpleAlert("Please fill all fields and select a file.");
    }
  };

  const [documentvalu, setdocumentvalu] = useState({
    file: "",
    subject: "",
    selectedDocument: ""
  })


  const handleInputChange1 = (key, value) => {
    setdocumentvalu((prev) => ({
      ...prev,
      [key]: value,
    }));
  };


  const years = Array.from({ length: 50 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { label: year.toString(), value: year.toString() };
  });

  const months = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
  ];

  // system fields
  const handleUpload = (e) => {
  };

  //edit address
  // const [visible, setVisible] = useState(false);
  // const [street1, setStreet1] = useState('White house');
  // const [street2, setStreet2] = useState(' Block-2, Hyderabad');
  // const [selectedCity, setSelectedCity] = useState(null);
  // const [selectedState, setSelectedState] = useState('');
  // const [selectedCountry, setSelectedCountry] = useState('');
  // const [postalCode, setPostalCode] = useState('');
  const [selectedLabel, setSelectedLabel] = useState(null);
  // const [selectedLabel1, setSelectedLabel1] = useState(null);

  const addCities = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' }
  ];

  const addStates = [
    { name: 'California', code: 'CA' },
    { name: 'Texas', code: 'TX' },
    { name: 'Florida', code: 'FL' },
    { name: 'New York', code: 'NY' },
    { name: 'Illinois', code: 'IL' }
  ];

  const addCountries = [
    { name: 'United States', code: 'US' },
    { name: 'Canada', code: 'CA' },
    { name: 'Germany', code: 'DE' },
    { name: 'India', code: 'IN' },
    { name: 'Australia', code: 'AU' }
  ];


  const labels = [
    { name: 'Work from Office', code: 'WORK' },
    { name: 'Work from Home', code: 'HOME' },
    { name: 'Work from Remote', code: 'REMOTE' },
    { name: 'Work from Hybrid', code: 'HYBRID' }
  ];

  // const [basicimp, setbasicimp] = useState('')
  // const [basictittle, setbasictittle] = useState('');
  // const [basicfirst, setbasicfirst] = useState('Venkata');
  // const [basiclast, setbasiclast] = useState('laxmi');
  // const [basicmiddle, setbasicmiddle] = useState('Valle');


  useEffect(() => {
    const updatedAddress = [street1, street2, postalCode, selectedState?.name, selectedCity?.name, selectedCountry?.name, selectedLabel?.name, postalCode].filter(Boolean);
    setAddress(updatedAddress);

    const updatenamesbasic = [basictittle, basicfirst, basicmiddle, basiclast].filter(Boolean).join(" ");
    // setbasicimp(updatenamesbasic)

  }, [street1, street2, postalCode, selectedState, selectedCity, selectedCountry, selectedLabel, postalCode, basictittle, basicfirst, basicmiddle, basiclast]);


  //documents popup type
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  
  useEffect(() => {
  const fetchDocumentTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-document-type/");
      if (response.data && response.data.results) {
        setDocumentTypes(response.data.results);
      }
    } catch (error) {
      setDocumentTypes([]);
      console.error("Error fetching document types:", error);
    }
  };
  fetchDocumentTypes();
}, []);

  const groupedDocuments = [
    {
      label: 'Proof of Identity',
      items: [
        { label: 'Aadhaar Card', value: 'Aadhaar Card' },
        { label: 'Passport', value: 'Passport' },
        { label: 'Voter ID', value: 'Voter ID' },
        { label: 'PAN Card', value: 'PAN Card' },
        { label: 'Driver\'s License', value: 'Driver\'s License' }
      ]
    },
    {
      label: 'Educational Qualification Documents',
      items: [
        { label: '10th, 12th Standard Mark Sheets', value: '10th, 12th Standard Mark Sheets' },
        { label: 'Degree/Diploma Certificates', value: 'Degree/Diploma Certificates' },
        { label: 'Consolidated Mark Sheets', value: 'Consolidated Mark Sheets' },
        { label: 'Professional Certification Documents', value: 'Professional Certification Documents' }
      ]
    },
    {
      label: 'Employment-Related Documents',
      items: [
        { label: 'Offer Letter', value: 'Offer Letter' },
        { label: 'Appointment Letter', value: 'Appointment Letter' },
        { label: 'Resume/Curriculum Vitae', value: 'Resume/Curriculum Vitae' },
        { label: 'Previous Employment Experience Certificates', value: 'Previous Employment Experience Certificates' },
        { label: 'Relieving Letters from Previous Employers', value: 'Relieving Letters from Previous Employers' },
        { label: 'Service Certificate', value: 'Service Certificate' },
        { label: 'Last Drawn Salary Slip', value: 'Last Drawn Salary Slip' }
      ]
    },
    {
      label: 'Contact and Address Proof',
      items: [
        { label: 'Permanent Address Proof', value: 'Permanent Address Proof' },
        { label: 'Current Residential Address Proof', value: 'Current Residential Address Proof' },
        { label: 'Local Address Proof', value: 'Local Address Proof' },
        { label: 'Address Verification Documents', value: 'Address Verification Documents' },
        { label: 'Contact Information Form', value: 'Contact Information Form' }
      ]
    },
    {
      label: 'Financial and Tax-Related Documents',
      items: [
        { label: 'PAN Card', value: 'PAN Card' },
        { label: 'Bank Account Details', value: 'Bank Account Details' },
        { label: 'Cancelled Cheque', value: 'Cancelled Cheque' },
        { label: 'Form 16 from Previous Employer', value: 'Form 16 from Previous Employer' },
        { label: 'Tax Identification Documents', value: 'Tax Identification Documents' }
      ]
    },
    {
      label: 'Personal and Medical Documents',
      items: [
        { label: 'Passport-Size Photographs', value: 'Passport-Size Photographs' },
        { label: 'Birth Certificate', value: 'Birth Certificate' },
        { label: 'Marriage Certificate (if applicable)', value: 'Marriage Certificate (if applicable)' },
        { label: 'Passport Details', value: 'Passport Details' },
        { label: 'Medical Fitness Certificate', value: 'Medical Fitness Certificate' },
        { label: 'Police Verification Certificate', value: 'Police Verification Certificate' }
      ]
    },
    {
      label: 'Legal and Compliance Documents',
      items: [
        { label: 'Background Verification Consent Form', value: 'Background Verification Consent Form' },
        { label: 'Non-Disclosure Agreement (NDA)', value: 'Non-Disclosure Agreement (NDA)' },
        { label: 'Employment Bond (if applicable)', value: 'Employment Bond (if applicable)' },
        { label: 'Declaration of No Criminal Record', value: 'Declaration of No Criminal Record' }
      ]
    },
    {
      label: 'Statutory Documentation',
      items: [
        { label: 'Employee Provident Fund (EPF) Registration Form', value: 'Employee Provident Fund (EPF) Registration Form' },
        { label: 'Employee State Insurance (ESI) Form', value: 'Employee State Insurance (ESI) Form' },
        { label: 'Professional Tax Registration Details', value: 'Professional Tax Registration Details' }
      ]
    },
    {
      label: 'Emergency Contact and Nominee Details',
      items: [
        { label: 'Emergency Contact Information Form', value: 'Emergency Contact Information Form' },
        { label: 'Nominee Details for Insurance and Other Benefits', value: 'Nominee Details for Insurance and Other Benefits' },
        { label: 'Personal References', value: 'Personal References' }
      ]
    },
    {
      label: 'Additional Specialized Documents (Depending on Role/Industry)',
      items: [
        { label: 'Professional License Certificates', value: 'Professional License Certificates' },
        { label: 'Specialized Skill Certification', value: 'Specialized Skill Certification' },
        { label: 'Work Permit/Visa Documents (for Foreign Nationals)', value: 'Work Permit/Visa Documents (for Foreign Nationals)' },
        { label: 'Security Clearance Certificates', value: 'Security Clearance Certificates' }
      ]
    }
  ];

  useEffect(() => {
  const fetchEmployeeTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-employee-type/");
      if (response.data && response.data.results) {
        setEmployeeTypes(response.data.results);
      }
    } catch (error) {
      setEmployeeTypes([]);
      console.error("Error fetching employee types:", error);
    }
  };
  fetchEmployeeTypes();
}, []);

  useEffect(() => {
    const fetchReferredByOptions = async () => {
      try {
        const response = await axios.get("/api/v1/get-all-referred-by/");
        if (response.data && response.data.results) {
          setReferredByOptions(response.data.results);
        }
      } catch (error) {
        setReferredByOptions([]);
        console.error("Error fetching referred by options:", error);
      }
    };
    fetchReferredByOptions();
  }, []);
  const groupedItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <i className="pi pi-file mr-2"></i>
        <div>{option.label}</div>
      </div>
    );
  };

  // categories

  // const [categories] = useState([
  //   {
  //     key: "0",
  //     label: "Skills",
  //     children: [
  //       {
  //         key: "0-0",
  //         label: "Frontend",
  //         children: [
  //           { key: "0-0-0", label: "React" },
  //           { key: "0-0-1", label: "Angular" },
  //           { key: "0-0-2", label: "Bootstrap" },
  //         ],
  //       },
  //       {
  //         key: "0-1",
  //         label: "Backend",
  //         children: [
  //           { key: "0-1-0", label: "Python" },
  //           { key: "0-1-1", label: "Java" },
  //           { key: "0-1-2", label: "C#" },
  //         ],
  //       },
  //       {
  //         key: "0-2",
  //         label: "QA",
  //         children: [
  //           { key: "0-2-0", label: "Manual" },
  //           { key: "0-2-1", label: "Automation" },
  //         ],
  //       },
  //     ],
  //   },
  // ]);

  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);

  //groups

  // const [groups] = useState([
  //   {
  //     key: "0",
  //     label: "Skills",
  //     children: [
  //       {
  //         key: "0-0",
  //         label: "Frontend",
  //         children: [
  //           { key: "0-0-0", label: "React" },
  //           { key: "0-0-1", label: "Angular" },
  //           { key: "0-0-2", label: "Bootstrap" },
  //         ],
  //       },
  //       {
  //         key: "0-1",
  //         label: "Backend",
  //         children: [
  //           { key: "0-1-0", label: "Python" },
  //           { key: "0-1-1", label: "Java" },
  //           { key: "0-1-2", label: "C#" },
  //         ],
  //       },
  //       {
  //         key: "0-2",
  //         label: "QA",
  //         children: [
  //           { key: "0-2-0", label: "Manual" },
  //           { key: "0-2-1", label: "Automation" },
  //         ],
  //       },
  //     ],
  //   },
  // ]);

  const [selectedGroupKey, setSelectedGroupKey] = useState(null);

  const setstatus = [
    { name: "Active", code: "act" },
    { name: "Inactive", code: "inc" },
  ]

  // const [primarySkills, setPrimarySkills] = useState(null);
  const primary = [
    { name: 'JavaScript' },
    { name: 'React' },
    { name: 'Node.js' },
    { name: 'CSS' }
  ];


  // const [secondarySkills, setSecondarySkills] = useState(null);
  const secondary = [
    { name: 'SQL' },
    { name: 'Python' },
    { name: 'Java' },
    { name: 'PHP' }
  ];

  // const [otherSkills, setOtherSkills] = useState([]);
  const other = [
    { name: 'Git' },
    { name: 'Docker' },
    { name: 'Kubernetes' },
    { name: 'AWS' }
  ];



  // Templates for Dropdown items
  const skillOptionTemplate = (option) => {
    return <div>{option.name}</div>;
  };


  const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    const file = event.files[0];
    const reader = new FileReader();
    let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

    reader.readAsDataURL(blob);

    reader.onloadend = function () {
      const base64data = reader.result;
    };
  };


  // const [dateAvalibility, setDateAvalibility] = useState(null);
  // const [dob, setDob] = useState(null);


  const [EmployeeRec, setEmployeeRec] = useState("  ")

  //  work experience variables start

  // const [workExperiences, setWorkExperiences] = useState([]);
  // const [showDialog, setShowDialog] = useState(false);
  const [showworkexpDialog, setShowworkexpDialog] = useState(false);
  const [formValues, setFormValues] = useState({
    company: "",
    website: "",
    jobTitle: "",
    fromDate: null,
    toDate: null,
    description: "",
  });
  const [editIndex1, setEditIndex1] = useState(null);
  const [editIndex, setEditIndex] = useState(null);

  // Form Handlers
  const handleInputChange = (key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = () => {
    if (editIndex !== null) {
      // Update existing record
      const updatedExperiences = [...workExperiences];
      updatedExperiences[editIndex] = formValues;
      setWorkExperiences(updatedExperiences);
      setEditIndex(null);
    } else {
      // Add new record
      setWorkExperiences([...workExperiences, formValues]);
    }
    setFormValues({
      company: "",
      website: "",
      jobTitle: "",
      fromDate: null,
      toDate: null,
      description: "",
    });
    setShowworkexpDialog(false);
  };

  const handleEdit = (rowData, index) => {
    setFormValues(rowData);
    setEditIndex(index);
    setShowworkexpDialog(true);
  };

  // Delete Functionality with Confirmation
  const handleDelete = (index) => {
    confirmDialog({
      message: "Are you sure you want to delete this work experience?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        setWorkExperiences((prev) => prev.filter((_, i) => i !== index));
      },
      reject: () => {
      },
    });
  };



  // Table Action Buttons
  const actionBodyTemplate = (rowData, column) => {
    const index = column.rowIndex;
    return (
      <div className="d-flex">
        <Button className="trashbtn mr-1" onClick={() => handleEdit(rowData, index)}>
          <i className="pi pi-pencil"></i>
        </Button>
        <Button className="trashbtn p-0" onClick={() => handleDelete(index)}>
          <i className="pi pi-trash"></i>
        </Button>
      </div>
    );
  };


  //  work experience variables end

  // Documents variable start


  const [selectedStatus1, setSelectedStatus1] = useState(null);  // Renamed to setSelectedStatus1
  const [subject, setSubject] = useState('');
  const [file, setFile] = useState(null);
  // const [documents, setDocuments] = useState([]);
  const [displayDialog, setDisplayDialog] = useState(false); // Modal visibility state

  // Sample status options (Renamed to setstatus1)
  const setstatus1 = [
    { name: 'Draft', code: 'draft' },
    { name: 'Final', code: 'final' },
    { name: 'Archived', code: 'archived' },
  ];

  // Custom uploader function (Renamed to customBase64Uploader2)
  const customBase64Uploader2 = (event) => {
    const file = event.files[0]; // Get the first file from the event
    if (file) {
      setdocumentvalu((prev) => ({
        ...prev,
        file: file, // Store the file object directly
      }));
    }
  };

  // Handle Add Document
  const handleAddDocument = () => {
    if (selectedStatus1 && subject && file) {
      const newDocument = { type: selectedStatus1.name, subject, file };
      setDocuments([...documents, newDocument]);
      alert('Document added successfully!');
      setDisplayDialog(false); // Close the modal after adding the document
    } else {
      alert('Please fill all the fields.');
    }
  };

  // Open the modal to add a new document
  const openAddDocumentDialog = () => {
    setDisplayDialog(true);
  };

  // Close the modal
  const closeAddDocumentDialog = () => {
    setDisplayDialog(false);
  };


  // Documents variable end


  // const navigate = useNavigate();

  const handleSaveClick = () => {
    // Perform any additional logic if needed
    // console.log('Save button clicked');

    // Navigate to another page
    setMerge(true);

  };
  const [pathSegment, setPathSegment] = useState(null);
  useEffect(() => {
    const url = new URL(window.location.href); // Get the current URL
    const pathParts = url.pathname.split('/'); // Split the pathname into parts
    const lastSegment = pathParts[pathParts.length - 1]; // Get the last part of the path

    setPathSegment(lastSegment); // Set the last segment to state

  }, []);

  const [merge, setMerge] = useState(false);
  const footerContent = (
    <div className="d-flex justify-content-center">
      <button type="button" onClick={() => {
        navigate('/all_active_employees');

      }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">Yes</button>

      <button type="button" onClick={() => {
        navigate('/all_active_employees');

      }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">No</button>
    </div>
  );
// ...existing code...
const {
  register,
  handleSubmit,
  setValue,
  getValues,
  reset,
  formState: { errors },
  trigger,
  watch,
  clearErrors,
} = useForm({
  mode: "onChange",
  defaultValues: {
    basicfirst: "",
    basictittle: "",
    basicmiddle: "",
    basiclast: "",
    company: "",
    jobtitle: "",
    status: "",
    totalExperience: "",
    email: "",
    phone: "",
    EmployeeType: "",
    source: "",
    referredBy: "",
    relocation: false,
    // ...add other fields as needed
  },
});
// ...existing code...

  const [linkdinval, setlinkdinval] = useState(null)
  const [facebook, setfacebook] = useState(null)
  const [twitter, settwitter] = useState(null)
  const [Indeed, setIndeed] = useState(null)
  const [HaveImagePan, setHaveImagePan] = useState(false);
  const [HaveImagePan2, setHaveImagePan2] = useState(true);
  const [imageNamepan, setImageNamepan] = useState('');
  const [PoliciesfilesErrorMessagepan, setPoliciesfilesErrorMessagepan] = useState();

  const onEmppanphoto = (data) => {
    const updatedImageValueapan = data.target.files[0].name
    const name = data.target.files[0].name;
    const lastDot = name.lastIndexOf('.');
    const ext = name.substring(lastDot + 1);
    setHaveImagePan2(false)
    if (ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "pdf") {

    } else {
      setValue("panphoto", null)
      setHaveImagePan(false)
      setPoliciesfilesErrorMessagepan('Please select valid file')
      return false
    }

    if (data.target.files[0].size > 2e6) {
      setValue("adharphoto", null)
      setHaveImagePan(false)
      setPoliciesfilesErrorMessagepan('Please select lower 2mb file')
      return false;
    }

    if (data.target.files.length === 1) {
      setPoliciesfilesErrorMessagepan('')
      setHaveImagePan(true)
      setImageNamepan(updatedImageValueapan)
    } else {
      setPoliciesfilesErrorMessagepan('This field is required')
      setHaveImagePan(false)
      setImageNamepan("")
      setImageNamepan('')
    }
  }
  const removeFileFromHerepan = () => {
    setValue("panphoto", "");
    setHaveImagePan(false);
  }

  const getcategoriesitem = async () => {
    try {
      const response = await axios.get(`/api/v1/candidates/${pathSegment}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data;
        setValue("firstname", results.first_name);
        setValue("lastname", results.last_name);
        setValue("jobtitle", results.job_title);
        setValue("personal_email", results.email);
        setValue("Email2", results.email_2);
        setValue("phone", results.mobile_phone);

        setValue("Company", results.country);

        console.log(results)

      }
    } catch (error) {

    }
  };

  useEffect(() => {
    if (pathSegment) {
      getcategoriesitem();
      // Call the function once the pathSegment is set
    }
  }, [pathSegment]);

  const [otherSkillsval, setotherSkillsval] = useState([])
  const [secondarySkillsval, setsecondarySkillsval] = useState([])
  const [primarySkillsvalu, setprimarySkillsvalu] = useState([])

  const getgroupsitem = async () => {

    try {
      const response = await axios.get(`/api/v1/get-all-skills/`, {
      });
      if (response.data && response.data.results) {
        const treeData = response.data.results;
        setotherSkillsval(treeData);
        setsecondarySkillsval(treeData)
        setprimarySkillsvalu(treeData)
      }

    } catch (error) {

    }
  };
  useEffect(() => {
    getgroupsitem()
  }, [])


  //handle tabs
  const [activeIndex, setActiveIndex] = useState(0); // Track the active tab

  // Function to go to the next tab
  const nextTab = () => {
    if (activeIndex < 6) {  // Adjust '2' if you have more tabs
      setActiveIndex(activeIndex + 1);
    }
  };

  // Function to go to the previous tab
  const previousTab = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };


  // Handle form submissionfrelocationOptions
  // const onFormSubmit = (data) => {
  //   const formData = {
  //     fullname: basicimp,
  //     company,
  //     jobtitle,
  //     status: selectedStatus,
  //     totalExperience,
  //     email,
  //     address: [street1, street2, selectedCity?.name, selectedState?.name, selectedCountry?.name, postalCode].filter(Boolean).join(", "),
  //     primarySkills,
  //     secondarySkills,
  //     otherSkills,
  //     currentSalary,
  //     phone,
  //     expectedSalary,
  //     employeeType: getValues("EmployeeType"),
  //     dateofbirth: dob,
  //     relocation: getValues("relocation"),
  //     dateAvalibility,
  //     source: source,
  //     referredBy: referredBy,
  //     selectedCategoryKey,
  //     selectedGroupKey,
  //     workExperiences,
  //     educationDetails,
  //     documents,
  //   };
  //   const isFirstNameValid = validateFirstName(basicfirst);
  //   const isEmailValid = validateEmail(email);
  //   const isPhoneValid = validatePhone(phone);
  //   if (isFirstNameValid && isEmailValid && isPhoneValid) {
  //     // Proceed with form submission
  //     console.log('Form is valid, proceed with submission');
  //     setSubmittedData(formData);
  //     setShowDialog(true);
  //   } else {
  //     console.log('Form has validation errors');
  //   }


  // };

// ...existing code...

const onFormSubmit = (formData) => {
  // Gather all data from state and react-hook-form
  const previewData = {
    // Basic Info
    fullname: [basictittle, basicfirst, basicmiddle, basiclast].filter(Boolean).join(" "),
    basictittle,
    basicfirst,
    basicmiddle,
    basiclast,
    company,
    jobtitle,
    status: selectedStatus,
    totalExperience,
    email: formData.email,
    phone: formData.phone,
    address: address,
    // Skills
    primarySkills,
    secondarySkills,
    otherSkills,
    currentSalary,
    expectedSalary,
    employeeType: formData.EmployeeType,
    dob,
    relocation: formData.relocation,
    dateAvalibility,
    source,
    referredBy,
    selectedCategoryNode, // <-- use the selected node, not key
    selectedGroupNode,
    workExperiences,
    educationDetails,
    documents,
    Email2: formData.Email2,
  };
  setSubmittedData(previewData);
  setShowDialog(true);
};

  const handleCloseDialog = () => {
    setShowDialog(false); // Close the dialog
  };


  // const [Upload, setUpload] = useState(false)

  const handleSelectResume = () => {
    setUpload(true);

  };

  const navigate = useNavigate();

  // const handleThankyouSubmit = () => {
  //   setThankyou(true)
  // }

  const resetFormFields = () => {
    // Reset all state variables to their initial values
    setBasicfirst('');
    setBasicmiddle('');
    setBasiclast('');
    setBasicimp('');
    setCompany('');
    setJobtitle('');
    setTotalExperience(null);
    setEmail('');
    setStreet1('');
    setStreet2('');
    setSelectedCity(null);
    setSelectedState(null);
    setSelectedCountry(null);
    setPostalCode('');
    setSelectedLabel1(null);
    setPrimarySkills([]);
    setSecondarySkills([]);
    setOtherSkills([]);
    setCurrentSalary(null);
    setExpectedSalary(null);
    setDob(null);
    setDateAvalibility(null);
    setWorkExperiences([]);
    setEducationDetails([]);
    setDocuments([]);
    setSource('');
    setPhone('');
    setReferredBy('');
    setSelectedCategoryNode(null);
    setSelectedGroupNode(null);
    setSelectedStatus('');
     setResumeData(null); // Reset the resume data
    setUpload(false); // Close the form if needed
    reset(); // Reset react-hook-form fields if you are using it
  };

  const getSkillNames = (ids, allSkills) => {
  if (!Array.isArray(ids)) return [];
  return ids
    .map(id => {
      const skill = allSkills.find(item => item.skill_id === id);
      return skill ? skill.skill_name : id;
    })
    .filter(Boolean);
};

const getEmployeeTypeId = (employeeTypeName) => {
  const type = employeeTypes.find(t => t.employee_type === employeeTypeName);
  return type ? type.id : '';
};

  // lokesh submit
const popupHandleSubmit = async () => {
  setIsUploading(true);

  // Prepare the payload
  const data = submittedData;
  const primarySkillNames = getSkillNames(data.primarySkills, primarySkillsvalu);
  const secondarySkillNames = getSkillNames(data.secondarySkills, secondarySkillsval);
  const otherSkillNames = getSkillNames(data.otherSkills, otherSkillsval);
  const payload = {
    job_number: id,
    first_name: data.basicfirst || '',
    middle_name: data.basicmiddle || '',
    last_name: data.basiclast || '',
    email: data.email || '',
    phone: data.phone || '',
    address: {
      street1: street1 || '',
      street2: street2 || '',
      city: selectedCity?.name || '',
      state: selectedState?.name || '',
      country: selectedCountry?.name || '',
      postal_code: postalCode || '',
      label: selectedLabel1?.name || '',
    },
    company: data.company || '',
    job_title: data.jobtitle || '',
    status: data.status || 'Active',
    total_experience: data.totalExperience || '',
    primary_skills: primarySkillNames,
    secondary_skills: secondarySkillNames,
    other_skills: otherSkillNames,
    current_salary: data.currentSalary !== null && data.currentSalary !== undefined ? String(data.currentSalary) : '',
  expected_salary: data.expectedSalary !== null && data.expectedSalary !== undefined ? String(data.expectedSalary) : '',
    employee_type: getEmployeeTypeId(data.employeeType) || '',
    date_of_birth: dob ? moment(dob).format('YYYY-MM-DD') : null,
    availability_date: dateAvalibility ? moment(dateAvalibility).format('YYYY-MM-DD') : null,
    relocation: data.relocation || false,
    source: data.source || '',
    referred_by: data.referredBy || '',
    category_id: data.selectedCategoryNode ? (typeof data.selectedCategoryNode === 'object' ? data.selectedCategoryNode.key : data.selectedCategoryNode) : null,
  group_id: data.selectedGroupNode ? (typeof data.selectedGroupNode === 'object' ? data.selectedGroupNode.key : data.selectedGroupNode) : null,
    work_experiences: data.workExperiences.map((exp) => ({
      company: exp.company || '',
      website: exp.website || '',
      job_title: exp.jobTitle || '',
      from_date: exp.fromDate ? moment(exp.fromDate).format('YYYY-MM-DD') : '',
      to_date: exp.toDate ? moment(exp.toDate).format('YYYY-MM-DD') : '',
      description: exp.description || '',
    })),
    education_details: data.educationDetails.map((edu) => ({
      degree: edu.degree || '',
      institution: edu.institution || '',
      grade: edu.grade || '',
      start_year: edu.year || '',
      start_month: edu.month || '',
      end_year: edu.endYear || '',
      end_month: edu.endMonth || '',
    })),
    documents: await Promise.all(data.documents.map(async (doc) => ({
      type: doc.selectedDocument || '',
      subject: doc.subject || '',
      file_name: doc.file ? doc.file.name : '',
      file: doc.file ? await getBase64(doc.file) : '',
    }))),
    attachments: resumeData ? {
      file_name: resumeData.name,
      file_data: resumeData.base64,
      file_type: resumeData.type,
    } : {},
  };


  try {
    // Make the API call
    const response = await axios.post(
      '/api/v1/apply-job/upload_candidate/',
      payload,
    );

    if (response.status === 200 || response.status === 201) {
      triggerAlert("success", "Success", "Candidate Applied Successfully!");
      setShowDialog(false);
      resetFormFields(); // Reset form fields
      setValue("panphoto", null); // Remove uploaded resume
    }
  } catch (error) {
    console.error('Error submitting candidate details:', error);
    let errorMessage = 'An unexpected error occurred';
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMessage = 'Invalid request. Please check your data.';
          break;
        case 401:
          errorMessage = 'Authentication failed. Please log in again.';
          break;
        case 403:
          errorMessage = 'You do not have permission to perform this action.';
          break;
        default:
          errorMessage = error.response.data.message || `Server responded with status ${error.response.status}`;
      }
    } else if (error.request) {
      errorMessage = 'No response received from server.';
    } else {
      errorMessage = error.message;
    }
    triggerAlert("error", "Error", errorMessage);
  } finally {
    setIsUploading(false);
  }
};


  // const validateFirstName = (name) => {
  //   if (!name) {
  //     setErrors((prevErrors) => ({ ...prevErrors, basicfirst: 'First name is required' }));
  //     return false;
  //   } else if (!/^[A-Za-z][A-Za-z-\s&]+$/.test(name)) {
  //     setErrors((prevErrors) => ({ ...prevErrors, basicfirst: 'This field allows only alphabets and spaces, but does not accept a space as the first character.' }));
  //     return false;
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, basicfirst: '' }));
  //     return true;
  //   }
  // };

  // const validateEmail = (email) => {
  //   if (!email) {
  //     setErrors((prevErrors) => ({ ...prevErrors, email: 'Email is required' }));
  //     return false;
  //   } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
  //     setErrors((prevErrors) => ({ ...prevErrors, email: 'Invalid email address' }));
  //     return false;
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, email: '' }));
  //     return true;
  //   }
  // };
  // const validatePhone = (phone) => {
  //   if (!phone) {
  //     setErrors((prevErrors) => ({ ...prevErrors, phone: 'Phone number is required' }));
  //     return false;
  //   } else if (!/^[0-9]{10}$/.test(phone)) {
  //     setErrors((prevErrors) => ({ ...prevErrors, phone: 'Please enter a valid 10-digit phone number.' }));
  //     return false;
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, phone: '' }));
  //     return true;
  //   }
  // };

  // Inside the CandidateForm component lokesh
  const [jobData, setJobData] = useState(null);
  const [linkExpiredMessage, setLinkExpiredMessage] = useState(null);
  const { id } = useParams()

  useEffect(() => {
    const fetchJobData = async () => {
      try {
        const response = await axios.get(`/api/v1/apply-job/get-job/${id}/`);
        setJobData(response.data);
        setLinkExpiredMessage(null);
      } catch (error) {
        console.error('Error fetching job data:', error);
        // Try to extract a backend-provided message (e.g. "Link expired") and show it to the user
        const msg = error?.response?.data?.message || error?.message || 'Error fetching job data';
        if (msg) {
          setLinkExpiredMessage(msg);
        }
        setJobData(null);
      }
    };

    fetchJobData();
  }, []);

  

  // Function to map response data to form fields
const getString = (val) => {
  if (Array.isArray(val)) return val.length > 0 ? val[0] : '';
  return val || '';
};

const mapResponseToForm = (data) => {
  const candidate = data[0]; // Assuming single candidate data

  // Basic Information
const firstName = getString(candidate?.contact_info?.first_name);
setBasicfirst(firstName);
setValue("basicfirst", firstName); // update react-hook-form value
clearErrors("basicfirst");
  setBasicmiddle(getString(candidate?.contact_info?.middle_name));
  setBasiclast(getString(candidate?.contact_info?.last_name));
  setBasicimp(
    [getString(candidate?.contact_info?.first_name), getString(candidate?.contact_info?.middle_name), getString(candidate?.contact_info?.last_name)]
      .filter(Boolean)
      .join(" ")
  );
  setTotalExperience(
    Array.isArray(candidate?.contact_info?.total_experience)
      ? `${candidate?.contact_info?.total_experience[0]} years ${candidate?.contact_info?.total_experience[1]} months`
      : getString(candidate?.contact_info?.total_experience)
  );

  // Contact Information
  setEmail(getString(candidate?.contact_info?.email));
  setValue("email", getString(candidate?.contact_info?.email)); 
  setValue("phone", getString(candidate?.contact_info?.phone));
  setPhone(getString(candidate?.contact_info?.phone));

const cityName = getString(candidate?.contact_info?.city);
const stateName = getString(candidate?.contact_info?.region);
const countryName = getString(candidate?.contact_info?.country);
const postal = getString(candidate?.contact_info?.postal_code);
setStreet1(getString(candidate?.contact_info?.street1) || '');
setStreet2(getString(candidate?.contact_info?.street2) || '');
setPostalCode(postal);
const cityObj = cities?.find(c => c.name === cityName) || { name: cityName, code: cityName };
const stateObj = states?.find(s => s.name === stateName) || { name: stateName, code: stateName };
const countryObj = countries?.find(c => c.name === countryName) || { name: countryName, code: countryName };
setSelectedCity(cityObj);
setSelectedState(stateObj);
setSelectedCountry(countryObj);
const updatedAddress = [getString(candidate?.contact_info?.street1), getString(candidate?.contact_info?.street2), cityName, stateName, countryName, postal].filter(Boolean).join(', ');
setAddress(updatedAddress);

  // Skills
  setPrimarySkills(candidate?.primary_skills || []);
  setSecondarySkills(candidate?.secondary_skills || []);
  setOtherSkills(
    candidate?.skills
      ? candidate?.skills?.filter(
          (skill) =>
            !(candidate?.primary_skills || []).includes(skill) &&
            !(candidate?.secondary_skills || []).includes(skill)
        )
      : []
  );

  // Employment History
  const experiences = [];
  if (candidate?.employment_history?.employer_1?.employer_name) {
    experiences?.push({
      company: candidate?.employment_history?.employer_1?.employer_name,
      jobTitle: candidate?.employment_history?.employer_1?.position,
      fromDate: candidate?.employment_history?.employer_1?.start_date,
      toDate: candidate?.employment_history?.employer_1?.end_date,
      website: '',
      description: ''
    });
  }
  if (candidate?.employment_history?.employer_2?.employer_name) {
    experiences.push({
      company: candidate?.employment_history?.employer_2?.employer_name,
      jobTitle: candidate?.employment_history?.employer_2?.position,
      fromDate: candidate?.employment_history?.employer_2?.start_date,
      toDate: candidate?.employment_history?.employer_2?.end_date,
      website: '',
      description: ''
    });
  }
  setWorkExperiences(experiences);

  // Education History
  const educations = [];
  if (candidate?.education_history?.education_1?.degree_name) {
    educations.push({
      degree: candidate?.education_history?.education_1?.degree_name,
      institution: candidate?.education_history?.education_1?.school_name,
      year: candidate?.education_history?.education_1?.last_education_date || '',
      grade: '',
      month: '',
      endYear: '',
      endMonth: ''
    });
  }
  setEducationDetails(educations);

  // Open the form
  setUpload(true);
};

  const [resumeData, setResumeData] = useState(null);


 const customBase64Uploader1 = async (event) => {
  setIsUploading(true);
  setUpload(true);
  const token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...`;

  try {
    const file = event.files[0];
    if (!file) {
      throw new Error("No file selected");
    }

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const maxFileSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      throw new Error("Invalid file type. Please upload PDF or DOC files.");
    }

    if (file.size > maxFileSize) {
      throw new Error("File size exceeds 5MB limit.");
    }

    const formData = new FormData();
    formData.append("resume_files", file);

    const response = await axios.post("https://parsing.talentscan.ai/api/resume/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    });

    if (response.data.data && response.data.data.length > 0) {
      mapResponseToForm(response.data.data);
      const updatedFormData = {
        fullname: basicimp,
        company,
        jobtitle,
        status: selectedStatus,
        totalExperience,
        email,
        address: [street1, street2, selectedCity?.name, selectedState?.name, selectedCountry?.name, postalCode].filter(Boolean).join(", "),
        primarySkills,
        secondarySkills,
        otherSkills,
        currentSalary,
        phone,
        expectedSalary,
        employeeType: getValues("EmployeeType"),
        dateofbirth: dob,
        relocation: getValues("relocation"),
        dateAvalibility,
        source: source,
        referredBy: referredBy,
        selectedCategoryKey,
        selectedGroupKey,
        workExperiences,
        educationDetails,
        documents,
      };
      setSubmittedData(updatedFormData);
    }

    const base64Data = await getBase64(file);
    const resumeFile = {
      name: file.name,
      type: file.type,
      size: file.size,
      base64: base64Data,
    };

    setResumeData(resumeFile); // Set the resume data in the state variable
    console.log("resumeFile", resumeFile);
  } catch (error) {
    console.error("Error uploading file:", error);
    let errorMessage = "An unexpected error occurred";
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMessage = "Invalid request. Please check your file.";
          break;
        case 401:
          errorMessage = "Authentication failed. Please log in again.";
          break;
        case 403:
          errorMessage = "You do not have permission to upload.";
          break;
        case 413:
          errorMessage = "File is too large. Maximum 5MB allowed.";
          break;
        default:
          errorMessage = error.response.data.message || `Server responded with status ${error.response.status}`;
      }
    } else if (error.request) {
      errorMessage = "No response received from server.";
    } else {
      errorMessage = error.message;
    }
    triggerAlert("error", "Error", errorMessage);
  } finally {
    setIsUploading(false);
  }
};



  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header candidate-form">
          <Container fluid={true}>
            <Row className="align-items-center justify-content-between">
              <Col lg={8}>
                <div className="d-flex">
                  <div className="navbar-brand-box">
                    <Link to="/" className="logo logo-dark">
                      <span className="logo-sm">
                        <img src={AtsImg} height="50" />
                      </span>
                      <span className="logo-lg">
                        <img src={AtsImg} height="50" />
                      </span>
                    </Link>

                    <Link to="/" className="logo logo-light">
                      <span className="logo-sm favicon-logo">
                        <img src={AtsImg} alt="" height="50" />
                      </span>
                      <span className="logo-lg barath-logo">
                        <img src={AtsImg} alt="" height="50" />
                      </span>
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="d-flex justify-content-end">
                  <a
                    href="https://qaats.pranathiss.com/allactive-jobs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-3"
                  >
                    Home
                  </a>
                  <a
                    href="https://qaats.pranathiss.com/allactive-jobs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help
                  </a>
                </div>
              </Col>

            </Row>
          </Container>
        </div>
      </header>
      <div className="page-content candidate-form">
        <Container fluid={true}>

          {linkExpiredMessage ? (
            <Row className="justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
              <Col md={10} lg={8} className="text-center">
                <Card className="p-4 shadow-sm border-0" style={{ maxWidth: 720, margin: '0 auto', borderRadius: 8, background: '#fff6f6', border: '1px solid #ffd6d6' }}>
                  <div className="pb-2">
                    <i className="pi pi-exclamation-circle" style={{ fontSize: 48, color: '#d9534f' }}></i>
                  </div>
                  <h2 className="mb-2" style={{ color: '#c9302c' }}>Link expired</h2>
                  <p className="mb-3 text-muted">The application link is no longer valid. </p>
                  <div>
                    {/* <Link to="/" className="btn btn-outline-danger px-4">Return to site</Link> */}
                  </div>
                </Card>
              </Col>
            </Row>
          ) : (
            <>
            <Row>
            <Col xl={12}>
              <div className="job-posting-container">
                <div className="job-posting-card">
                  {/* Header Section */}
                  <div className="job-header">
                    <div className="job-header-content">
                      <h2 className="job-title">
                        {jobData?.job_title || 'No Job Title'} <span className="job-id">({jobData?.job_number})</span>
                      </h2>
                      <div className="job-badges">
                        <div className="job-badge">
                          ₹{jobData?.salary_min || '0'} to ₹{jobData?.salary_max || '0'}
                        </div>
                        <div className="job-badge">
                          {jobData?.location_name || 'Hyderabad, Telangana, India'}
                        </div>
                        <div className="job-badge">
                          {jobData?.job_type_name || 'Full Time'}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="divider"></div>

                  {/* Job Title Section */}
                  <div className="job-section">
                    <h3 className="section-title">Job Title</h3>
                    <p className="section-content">
                      {jobData?.job_title
                        ? `${jobData?.job_title} at ${jobData?.company_name || 'N/A'}, based out of ${jobData?.location_name || 'Hyderabad, Telangana, India'} - ${jobData?.job_type_name || 'Full Time'}`
                        : 'React Frontend Developer at PACTAP, based out of New Delhi - Onsite Role'}
                    </p>
                  </div>

                  {/* Company Details Section */}
                  <div className="job-section">
                    <h3 className="section-title">Company Details</h3>
                    <p className="section-content">
                      {jobData?.company_description ||
                        'No Company Description Available'}
                    </p>
                  </div>

                  {/* Job Roles & Responsibilities Section */}
                  <div className="job-section">
                    <h3 className="section-title">Job Roles & Responsibilities</h3>
                    {/* <ul className="job-list">
                        {jobData?.job_description?.length > 0 ? (
                          jobData.job_description.map((responsibility, index) => (
                            <li key={index}>{responsibility}</li>
                          ))
                        ) : (
                          <>
                            <li>Develop and maintain web applications using Angular, ensuring seamless functionality and user experience.</li>
                            <li>Collaborate with UX/UI designers to implement responsive and interactive designs.</li>
                            <li>Optimize frontend components for maximum performance and scalability.</li>
                            <li>Troubleshoot and debug application issues to enhance user engagement.</li>
                            <li>Integrate RESTful APIs to facilitate data exchange between frontend and backend systems.</li>
                            <li>Ensure code quality by writing reusable, testable, and efficient code objects.</li>
                            <li>Keep abreast of the latest industry trends in Angular and related technologies.</li>
                            <li>Collaborate with cross-functional teams to deliver tech-enabled solutions for packaging processes.</li>
                          </>
                        )}
                      </ul> */}
                    <div dangerouslySetInnerHTML={{ __html: jobData?.job_description || "No Job Description Available" }} />
                  </div>

                  {/* Cultural Expectations Section */}
                  {/* <div className="job-section">
                      <h3 className="section-title">Cultural Expectations</h3>
                      <ul className="job-list">
                        {jobData?.cultural_expectations?.length > 0 ? (
                          jobData.cultural_expectations.map((expectation, index) => (
                            <li key={index}>{expectation}</li>
                          ))
                        ) : (
                          <>
                            <li>Embrace innovative approaches and adapt to evolving technologies</li>
                            <li>Foster a collaborative environment with cross-functional teams</li>
                            <li>Maintain a commitment to sustainable and environmentally friendly practices</li>
                            <li>Communicate effectively with diverse stakeholders</li>
                            <li>Uphold high-quality standards in code and design decisions</li>
                          </>
                        )}
                      </ul>
                    </div> */}

                  {/* Hiring Process Section */}
                  {/* <div className="job-section">
                      <h3 className="section-title">Hiring Process</h3>
                      <ol className="job-list-ordered">
                        {jobData?.hiring_process?.length > 0 ? (
                          jobData.hiring_process.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))
                        ) : (
                          <>
                            <li>Profile shortlisting</li>
                            <li>Tech interview</li>
                            <li>Tech interview</li>
                            <li>Founder/Leader interview</li>
                          </>
                        )}
                      </ol>
                    </div> */}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="apply-small-form">
            <Col lg={12}>
              <div className="application-form-container">
                <Card className="p-shadow-5 application-card" style={{ backgroundColor: '#fff', border: '1px solid #eee' }}>
                  <h2 className="form-title">Fill details to apply</h2>
                  <p className="form-subtitle">Choose among the one ways to apply for jobs.</p>
                  {/* <h3 className="quick-apply-title">Quick apply through any 1 of the below</h3> */}

                  <div className="quick-apply-flex">
                    <div className="option-wrapper">
                      <Card className="option-card">
                        <FileUpload
                          mode="basic"
                          name="demo[]"
                          url="/api/upload"
                          accept=".pdf, .doc, .docx"
                          onSelect={customBase64Uploader1}
                          maxFileSize={1000000}
                          className="file-upload-input"
                          chooseLabel={isUploading ? "Uploading..." : "Upload Resume"}
                          disabled={isUploading}
                        />
                        {isUploading && (
                          <div className="loading-overlay">
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                          </div>
                        )}
                        <p className="option-description">Accepted formats: PDF, DOC, DOCX</p>
                      </Card>
                    </div>
                    <div className="option-wrapper">
                      <Card className="option-card">
                        <Button
                          onClick={handleSelectResume}
                          label="Fill the form"
                          className="p-button-outlined p-button-secondary"
                          disabled={isUploading}
                        />
                        <p className="option-description">Fill the Detail form Manually with all the details</p>
                      </Card>
                    </div>
                  </div>

                  {/* <Divider align="center">Or</Divider> */}

                  {/* <div className="apply-email">
                    <Card className="option-card">
                        <Button
                            icon="pi pi-envelope"
                            label="Fill the form"
                            className="p-button-outlined p-button-secondary"
                        />
                        <p className="option-description">8-input Job application</p>
                    </Card>
                </div> */}
                </Card>
              </div>
            </Col>
          </Row>

            </>
          )}

          {
            Upload &&
            // <div className="application-form-container">
            <Container>
              <Row>
                <Col lg={12}>
                  <h3 className="candet-head mb-4">Candidate Details Form</h3>
                </Col>
              </Row>
              {/* view start*/}
              <div className="details-dialog" header="Review Your Details" visible={showDialog} onHide={handleCloseDialog}
                breakpoints={{ '960px': '75vw' }} >
                {/* Basic Information start */}
                <Row>
                  <Col lg={12}>
                    {/* Basic Information */}
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <h4 className="pre-txthead">Basic Information</h4>
                          </div>
                          <div className="">
                            <Row className="mb-3">
                              <Col lg={4}>
                                <div className="p-field">
                                  <label htmlFor="fullName" className="block">Full Name</label>
                                  <div style={{ position: "relative" }}>
                                    <InputText
                                      className="w-full"
                                      // placeholder="Enter your Name"
                                      value={basicimp}

                                    />
                                    {errors.firstname && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.firstname.message}</small>)}
                                    <i className="pi pi-pencil" style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "52%",
                                      transform: "translateY(-50%)", color: "#6c757d", cursor: "pointer"
                                    }}
                                      onClick={() => setFullNameDialogVisible(true)}
                                    ></i>
                                  </div>

                                  <Dialog
                                    header="Edit Full Name"
                                    visible={fullNameDialogVisible}
                                    onHide={() => setFullNameDialogVisible(false)}
                                    style={{ width: '30vw' }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                  >

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Title
                                        </label>
                                        <select
                                          className="form-select mb-1"
                                          value={basictittle}
                                          onChange={(e) => { setBasictittle(e.target.value); }}
                                        >
                                          <option value="">Select Title</option>
                                          <option value="Mr.">Mr.</option>
                                          <option value="Mrs">Mrs</option>
                                          <option value="Miss">Miss</option>
                                          <option value="Ms">Ms</option>
                                        </select>

                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          First Name <span className="text-danger">*</span>
                                        </label>
                                        <InputText
  className="w-full"
  placeholder="Enter your First Name"
  value={basicfirst}
  {...register("basicfirst", {
    required: "First name is required",
    pattern: {
      value: /^[A-Za-z][A-Za-z-\s&]+$/,
      message: "Only alphabets and spaces, no space at start.",
    },
    onChange: (e) => setBasicfirst(e.target.value),
  })}
  onChange={e => setBasicfirst(e.target.value)}
/>
{errors.basicfirst && <small className='form-text text-danger'>{errors.basicfirst.message}</small>}
                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Middle Name
                                        </label>
                                        <InputText
                                          id="title"
                                          className="w-full"
                                          value={basicmiddle}
                                          onChange={(e) => { setBasicmiddle(e.target.value); }}
                                        />
                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Last Name
                                        </label>
                                        <InputText
                                          id="title"
                                          className="w-full"
                                          value={basiclast}
                                          onChange={(e) => { setBasiclast(e.target.value); }}
                                        />
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col xl={12}>
                                        <div className="d-flex justify-content-end mt-2">
                                          <Button color="primary btn-main mr-2" onClick={() => {
                                            setBasicimp([basictittle, basicfirst, basicmiddle, basiclast].filter(Boolean).join(" "));
                                            setFullNameDialogVisible(false);
                                          }}>
                                            Ok
                                          </Button>
                                          <Button onClick={() => setFullNameDialogVisible(false)} color="btn btn-primary cancel-outlinebtn">
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                          </Button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Dialog>


                                  {/* <Dialog
          header="Header"
          visible={thankyou}
          onHide={() => {
           
            setThankyou(false);
          }}
          style={{ width: '50vw' }}
          breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        >
          <p className="m-0">
            Lorem sdsdd ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
                                  </Dialog> */}

                                  <Dialog
                                    header="Thank You!"
                                    visible={thankyou}
                                    onHide={() => setThankyou(false)} // Close dialog when clicked outside
                                    style={{ width: "30vw", textAlign: "center" }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                  >
                                    {/* Image in the Dialog */}
                                    <img
                                      src={Thankyou} // Replace with your custom "Thank You" image
                                      alt="Thank You"
                                      style={{

                                      }}
                                      className="thankyou-img"
                                    />
                                    <p className="m-0" style={{ marginTop: "20px", fontSize: "1rem", color: "#555" }}>
                                      Thank you for your submission! We'll get back to you soon.
                                    </p>
                                    <Button
                                      label="Close"
                                      icon="pi pi-check"
                                      onClick={() => setThankyou(false)} // Close the dialog on button click
                                      className="p-button-primary"
                                      style={{ marginTop: "20px" }}
                                    />
                                  </Dialog>

                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="p-field">
                                  <label htmlFor="company" className="block">Company</label>
                                  <InputText
                                    value={company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    className="w-full"
                                    // placeholder="Ex: Pranathi software services"
                                  // {...register("Company", {
                                  //   // required: "Company name is required",
                                  //   // pattern: {
                                  //   //   value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                  //   //   // message:
                                  //   //   //   "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                  //   // },
                                  // })}
                                  // onKeyUp={() => { trigger("Company") }}

                                  />
                                  {/* {errors.Company && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.Company.message}</small>)} */}

                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="p-field">
                                  <label htmlFor="jobTitle" className="block">Job Title</label>
                                  <InputText
                                    value={jobtitle}
                                    onChange={(e) => setJobtitle(e.target.value)}
                                    className="w-full"
                                    // placeholder="Ex: React Developer"
                                    // {...register("JobTitle", {
                                    //   // required: "JobTitle  is required",
                                    //   pattern: {
                                    //     value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                    //     // message:
                                    //     //   "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    //   },
                                    // })}
                                    onKeyUp={() => { trigger("JobTitle") }}
                                  />
                                  {/* {errors.JobTitle && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.JobTitle.message}</small>)} */}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col lg={4}>
                                <div className="p-field">
                                  <label htmlFor="status" className="block">Status</label>
                                  <select
                                    onChange={(e) => { setSelectedStatus(e.target.value); }}
                                    className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                                    aria-label='Default select example'
                                  >
                                    <option value=''>--Select --</option>
                                    <option value='Active'>Active</option>
                                    <option value='InActive'>InActive </option>

                                  </select>
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="p-field">
                                  <label htmlFor="totalExperience" className="block">Total Experience</label>

                                  <InputText
                                    inputId="totalExperience"
                                    value={totalExperience}
                                    onChange={(e) => setTotalExperience(e.target.value)}
                                    placeholder="Ex: 5 years"
                                    className="w-full drop-clr"
                                  />
                                </div>
                              </Col>

                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {/* Basic Information end */}

                <Row>
                  <Col lg={12}>

                    <div className="card p-4">
                      <Row className="mb-3">
                        <div className="d-flex mb-2">

                          <h4 className="pre-txthead">Contact Information</h4>
                        </div>
                        <Col lg={4}>
                          <div className="p-field">
                            <label htmlFor="email1" className="block">Email 1 <span className="text-danger">*</span></label>
                            <InputText
                            className="w-full"
                            placeholder="Enter your Email"
                            {...register("email", {
                            required: "Email is required",
                            pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
    },
  })}
/>
{errors.email && <small className='form-text text-danger'>{errors.email.message}</small>}
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="p-field">
                            <label htmlFor="email2" className="block">Email 2</label>
                            <InputText
                              className="w-full"
                              // placeholder='Ex: venkatalaxmi2@gmail.com'
                              {...register("Email2", {})}
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="p-field">
                            <label htmlFor="workPhone" className="block">Work Phone</label>
                            <InputText
                              id="integer"
                              // placeholder='Ex: 9876543210'
                              keyfilter="int"
                              className="w-full"
                            />
                          </div>
                        </Col>

                      </Row>
                      <Row className="mb-3">
                        <Col lg={4}>
  <div className="p-field">
    <label htmlFor="mobilePhone" className="block">Mobile Phone <span className="text-danger">*</span></label>

<InputText
  className="w-full"
  placeholder="Enter your Phone Number"
  {...register("phone", {
    required: "Mobile phone is required",
    validate: {
      notAllZeros: value => {
        const str = value ? String(value) : '';
        return !/^0+$/.test(str.replace(/\D/g, "")) || "Mobile number cannot be all zeros";
      },
      minDigits: value => {
        const digits = (value || '').replace(/\D/g, '');
        return digits?.length >= 10 || "Please enter at least 10 digits";
      }
    },
    pattern: {
    value: /^(\+|\()?[\d\s\-()]{10,}$/,
    message: "Please enter a valid phone number (e.g. +91 98765 43210 or (617) 123-4567)",
  },
    maxLength: {
      value: 20,
      message: "Please enter no more than 20 characters",
    },
  })}
  onKeyUp={() => trigger("phone")}
/>
{errors.phone && (
  <small className="text-danger">{errors.phone.message}</small>
)}
    {errors.phone && (
      <small className="text-danger">{errors.phone.message}</small>
    )}
  </div>
</Col>
                      </Row>
                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="address" className="block">Address</label>
                            <div className="companie-add" style={{ position: "relative" }}>
                              <InputTextarea
                                id="address"
                                value={address}
                                // onChange={(e) => setAddress(e.target.value)}
                                readOnly
                                placeholder=""
                                rows={3}
                                cols={20}
                                className="w-full"
                              />

                              {/* Edit Icon */}
                              <i
                                className="pi pi-pencil"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "70%",
                                  transform: "translateY(-50%)",
                                  color: "#6c757d",
                                  cursor: "pointer"
                                }}
                                onClick={() => {
    setTempStreet1(street1);
    setTempStreet2(street2);
    setTempPostalCode(postalCode);
    setTempSelectedCountry(selectedCountry);
    setTempSelectedState(selectedState);
    setTempSelectedCity(selectedCity);
    setTempSelectedLabel(selectedLabel1); // If you have address label
    setVisible(true);
  }}
                              ></i>


                              <Dialog
                                header="Edit Address"
                                className="address-popup"
                                visible={visible}
                                onHide={() => setVisible(false)}
                                style={{ width: '30vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                              >
                                <div className="card sidebardetails">
                                  <form onSubmit={(e) => e.preventDefault()}>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="street1">Street 1</label>
                                          <InputText
                                            id="street1"
                                            value={tempStreet1}
  onChange={(e) => setTempStreet1(e.target.value)}
                                            // placeholder="Enter Street 1"
                                            className="w-full activejobdrop"
                                          />
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="street2">Street 2</label>
                                        <InputText
                                          id="street2"
                                            value={tempStreet2}
                                            onChange={(e) => setTempStreet2(e.target.value)}
                                            // placeholder="Enter Street 2 (Optional)"
                                            className="w-full activejobdrop"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <label htmlFor="country">Country</label>
                                        <Dropdown
                                          id="country"
                                          value={tempSelectedCountry}
                                          onChange={(e) => { setTempSelectedCountry(e.value); setTempSelectedState(null); setTempSelectedCity(null); }}
                                          options={countries}
                                          optionLabel="name"
                                          filter
                                          filterPlaceholder="Search Country"
                                          className="w-full activejobdrop"
                                          // placeholder="Enter country details..."
                                        />
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="state">State</label>
                                        <Dropdown
                                          id="state"
                                          value={tempSelectedState}
                                          onChange={(e) => { setTempSelectedState(e.value); setTempSelectedCity(null); }}
                                          options={states}
                                          optionLabel="name"
                                          filter
                                          filterPlaceholder="Search State"
                                          className="w-full activejobdrop"
                                          // placeholder="Enter state details..."
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <label htmlFor="city">City</label>
                                        <Dropdown
                                          id="city"
                                          value={tempSelectedCity}
                                          onChange={(e) => setTempSelectedCity(e.value)}
                                          options={cities}
                                          optionLabel="name"
                                          filter
                                          filterPlaceholder="Search City"
                                          className="w-full activejobdrop"
                                          // placeholder="Enter city details..."
                                        />
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="postalCode">Postal Code</label>
                                        <InputText
                                          id="postalCode"
                                          value={tempPostalCode}
                                          onChange={(e) => setTempPostalCode(e.target.value)}
                                          // placeholder="Enter Postal Code"
                                          className="w-full activejobdrop"
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col xl={12}>
                                        <div className="d-flex justify-content-end mt-2">
                                          <Button
                                            type="button"
                                            color="primary btn-main mr-2"
                                            onClick={() => {
    setStreet1(tempStreet1);
    setStreet2(tempStreet2);
    setPostalCode(tempPostalCode);
    setSelectedCountry(tempSelectedCountry);
    setSelectedState(tempSelectedState);
    setSelectedCity(tempSelectedCity);
    // setSelectedLabel1(tempSelectedLabel); // If you use address label
    updateAddress();
    setVisible(false);
  }}
                                          >
                                            OK
                                          </Button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </form>
                                </div>
                              </Dialog>


                            </div>
                          </div>
                        </Col>
                      </Row>

                    </div>
                  </Col>
                </Row>

                {/* skill start */}
                <Row>
                  <Col lg={12}>
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <div>
                              <i className="pi pi-info-circle me-2 diaicon"></i>
                            </div>
                            <h4 className="pre-txthead">Skills</h4>
                          </div>
                          <Row className="mb-3">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="primarySkills" className="block">Primary Skills</label>
                                <MultiSelect
                                  value={primarySkills}
                                  options={primarySkillsvalu.map(item => ({ label: item.skill_name, value: item.skill_id }))}
                                  onChange={(e) => setPrimarySkills(e.value)}
                                  placeholder="Select Primary Skills"
                                  className="w-full"
                                  filter
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="secondarySkills" className="block">Secondary Skills</label>
                                <MultiSelect
                                  value={secondarySkills}
                                  options={secondarySkillsval.map(item => ({ label: item.skill_name, value: item.skill_id }))}
                                  onChange={(e) => setSecondarySkills(e.value)}
                                  placeholder="Select Secondary Skills"
                                  className="w-full"
                                  filter
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="otherSkills" className="block">Other Skills</label>
                                <MultiSelect
                                  value={otherSkills}
                                  options={otherSkillsval.map(item => ({ label: item.skill_name, value: item.skill_id }))}
                                  onChange={(e) => setOtherSkills(e.value)}
                                  placeholder="Select Other Skills"
                                  className="w-full"
                                  filter
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {/* skill end */}

                <Row>
                  <Col lg={12}>
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <div>
                              <i class="pi pi-star me-2 diaicon"></i>
                            </div>
                            <h4 className="pre-txthead">General Information</h4>
                          </div>

                          <Row className="mb-3">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="currentSalary" className="block">Current Salary</label>
                                <InputNumber
                                  inputId="currentSalary"
                                  value={currentSalary}
                                  onValueChange={(e) => setCurrentSalary(e.value)}
                                  mode="currency"
                                  currency="INR"
                                  locale="en-IN"
                                  // placeholder="Ex: 10LPA"
                                  className="w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="expectedSalary" className="block">Expected Salary</label>
                                <InputNumber
                                  inputId="expectedSalary"
                                  value={expectedSalary}
                                  onValueChange={(e) => setExpectedSalary(e.value)}
                                  mode="currency"
                                  currency="INR"
                                  locale="en-IN"
                                  // placeholder="Ex: 15LPA"
                                  className="w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="employeeType" className="block">Employee Type</label>
                               <select
  className='form-select profileDetailsInput'
  {...register("EmployeeType", {})}
  value={watch("EmployeeType")}
  onChange={e => setValue("EmployeeType", e.target.value)}
>
  <option value=''>--Select--</option>
  {employeeTypes.map(type => (
    <option key={type.id} value={type.employee_type}>
      {type.employee_type}
    </option>
  ))}
</select>
                              </div>
                            </Col>

                          </Row>
                          <Row className="mb-3">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="dob" className="block">Date of Birth</label>
                                <Calendar className="w-full"
                                  id="buttondisplay"
                                  value={dob}
                                  onChange={(e) => setDob(e.value)}
                                  showIcon
                                />
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="availabilityDate" className="block">Availability Date</label>
                                <Calendar className="w-100"
                                  id="buttondisplay"
                                  value={dateAvalibility}
                                  onChange={(e) => setDateAvalibility(e.value)}
                                  showIcon
                                />
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="relocation" className="block">Relocation</label>
                                <input
                                  type='checkbox'
                                  {...register("relocation", {})}
                                  onKeyUp={() => {
                                    trigger("relocation");
                                  }}
                                  className="me-2"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="source" className="block">Source</label>
                                <InputText
                                  className="w-full"
                                  // placeholder="Ex: LinkedIn"
                                  value={source}
                                  onChange={(e) => setSource(e.target.value)}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="referredBy" className="block">Referred By</label>
                                <Dropdown
                                  value={referredBy}
                                  onChange={(e) => setReferredBy(e.value)}
                                  options={referredByOptions.map(option => ({ label: option.value, value: option.value }))}
                                  placeholder="Select Referred By"
                                  className="w-full"
                                  filter
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="categories" className="block">Categories</label>
                                <TreeSelect
                                  value={selectedCategoryNode}
                                  onChange={(e) => setSelectedCategoryNode(e.value)}
                                  options={categoryNodes}
                                  filter
                                  className="w-full"
                                  placeholder="Select Category"
                                />
                              </div>
                            </Col>

                          </Row>
                          <Row className="mb-3">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="groups" className="block">Groups</label>
                                <TreeSelect
                                  value={selectedGroupNode}
                                  onChange={(e) => setSelectedGroupNode(e.value)}
                                  options={groupNodes}
                                  filter
                                  className="w-full"
                                  placeholder="Select Group"
                                />
                              </div>
                            </Col>
                          </Row>


                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <div>
                              <i className="pi pi-book me-2 diaicon"></i>
                            </div>
                            <h4 className="pre-txthead">Experience</h4>
                          </div>

                          <Row className="mb-3">
                            <Col lg={12}>
                              {/* Data Table */}
                              <DataTable value={workExperiences} responsiveLayout="scroll" className="mt-2"
                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                                <Column field="company" header="Company" />
                                <Column field="website" header="Website" />
                                <Column field="jobTitle" header="Job Title" />
                                 <Column
    field="fromDate"
    header="From Date"
    body={(rowData) => {
      if (!rowData.fromDate) return '';
      // If it's a Date object, format it
      if (rowData.fromDate instanceof Date) {
        return rowData.fromDate.toLocaleDateString();
      }
      // If it's a string, just show it
      return rowData.fromDate;
    }}
  />
  <Column
    field="toDate"
    header="To Date"
    body={(rowData) => {
      if (!rowData.toDate) return '';
      if (rowData.toDate instanceof Date) {
        return rowData.toDate.toLocaleDateString();
      }
      return rowData.toDate;
    }}
  />
                                {/* <Column field="description" header="Description" /> */}
                                {/* <Column header="Actions" body={actionBodyTemplate} /> */}
                              </DataTable>

                              <div className="block d-flex align-items-center justify-content-end">
                                <a color="primary" className="anchr-title  mt-3" onClick={() => setShowworkexpDialog(true)}>
                                  <i className="pi pi-plus me-1"></i> Add More
                                </a>
                              </div>



                              {/* Dialog for Adding/Editing */}
                              <Dialog
                                header={editIndex !== null ? "Edit Work Experience" : "Add Work Experience"}
                                visible={showworkexpDialog}
                                style={{ width: "30vw" }}
                                onHide={() => setShowworkexpDialog(false)}
                              >
                                <Row className="mb-2">
                                  <Col xl={12}>
                                    <label htmlFor="company" className="block">
                                      Company
                                    </label>
                                    <InputText
                                      className="w-full"
                                      value={formValues.company}
                                      onChange={(e) => handleInputChange("company", e.target.value)}
                                    // {...register("Company1", {
                                    //   required: "This field is required",
                                    //   pattern: {
                                    //     value: /^[a-zA-Z_ ]*$/,
                                    //     message:
                                    //       "Please enter valid Job Tittle ",
                                    //   },
                                    // })}
                                    // onKeyUp={() => { trigger("Company1") }}
                                    />
                                    {/* {errors.Company1 && (<small id='emailHelp' className='form-text text-danger'>{errors.Company1.message}</small>)} */}
                                  </Col>
                                </Row>

                                <Row className="mb-2">
                                  <Col xl={12}>
                                    <label htmlFor="website" className="block">
                                      Website
                                    </label>
                                    <InputText
                                      id="website"
                                      value={formValues.website}
                                      onChange={(e) => handleInputChange("website", e.target.value)}
                                      className="w-full"
                                    />
                                  </Col>
                                </Row>


                                <Row className="mb-2">

                                  <Col xl={12}>
                                    <label htmlFor="jobTitle" className="block">
                                      Job Title
                                    </label>
                                    <InputText
                                      id="jobTitle"
                                      value={formValues.jobTitle}
                                      onChange={(e) => handleInputChange("jobTitle", e.target.value)}
                                      className="w-full"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-2">

                                  <Col xl={12}>
                                    <label htmlFor="fromDate" className="block">
                                      From Date
                                    </label>
                                    <Calendar
                                      id="fromDate"
                                      value={formValues.fromDate}
                                      onChange={(e) => handleInputChange("fromDate", e.value)}
                                      showIcon
                                      className="w-full"
                                    />
                                  </Col>
                                </Row>

                                <Row className="mb-2">

                                  <Col xl={12}>
                                    <label htmlFor="toDate" className="block">
                                      To Date
                                    </label>
                                    <Calendar
                                      id="toDate"
                                      value={formValues.toDate}
                                      onChange={(e) => handleInputChange("toDate", e.value)}
                                      showIcon
                                      className="w-full"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-end mt-2">
                                      <Button color="primary btn-main mr-2" onClick={handleSave}>
                                        Ok
                                      </Button>
                                      {/* <Button color="btn btn-primary cancel-outlinebtn" onClick={() => setShowDialog(false)}>
                              <i className="pi pi-times me-1"></i>
                              Cancel
                            </Button> */}
                                    </div>
                                  </Col>
                                </Row>
                              </Dialog>
                            </Col>
                          </Row>

                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <div>
                              <i className="pi pi-graduation-cap me-2 diaicon"></i>
                            </div>
                            <h4 className="pre-txthead">Education</h4>
                          </div>

                          <Row className="mb-3">
                            <Col lg={12}>
                              <DataTable
                                value={educationDetails}
                                showGridlines
                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}
                              // tableStyle={{ minWidth: '30rem' }}
                              >
                                <Column field="degree" header="Degree"></Column>
                                <Column field="institution" header="School"></Column>
                                <Column field="grade" header="Grade"></Column>
                                <Column field="year" header="Year"></Column>
                              </DataTable>

                              <div className="block d-flex align-items-center justify-content-end">
                                <a color="primary" className="anchr-title mt-3" onClick={() => setIsDialogVisible(true)}>
                                  <i className="pi pi-plus me-1"></i> Add More
                                </a>
                              </div>


                              {/* Dialog for Adding New Education */}
                              <Dialog
                                header="Add Education"
                                visible={isDialogVisible}
                                style={{ width: '30vw' }}
                                onHide={() => setIsDialogVisible(false)}
                              >
                                <div className="field">
                                  <label htmlFor="degree" className="block mb-2">
                                    Degree
                                  </label>
                                  <InputText
                                    id="degree"
                                    value={newEducation.degree}
                                    onChange={(e) => setNewEducation({ ...newEducation, degree: e.target.value })}
                                    // placeholder="Enter Degree"
                                    className="w-full"
                                  />
                                </div>
                                <div className="field mt-2">
                                  <label htmlFor="institution" className="block mb-2">
                                    School
                                  </label>
                                  <InputText
                                    id="institution"
                                    value={newEducation.institution}
                                    onChange={(e) => setNewEducation({ ...newEducation, institution: e.target.value })}
                                    // placeholder="Enter Institution"
                                    className="w-full"
                                  />
                                </div>
                                <div className="field mt-2">
                                  <label htmlFor="grade" className="block mb-2">
                                    Grade
                                  </label>
                                  <InputText
                                    id="grade"
                                    value={newEducation.grade}
                                    onChange={(e) => setNewEducation({ ...newEducation, grade: e.target.value })}
                                    // placeholder="Enter Grade/Percentage"
                                    className="w-full"
                                  />
                                </div>

                                <Row>
                                  <Col xl={6}>
                                    <div className="field">
                                      <label htmlFor="year" className="block  mb-2">
                                        Start Year
                                      </label>
                                      <Dropdown
                                        id="year"
                                        value={newEducation.year}
                                        onChange={(e) => setNewEducation({ ...newEducation, year: e.value })}
                                        options={years}
                                        placeholder="Select Year"
                                        className="w-full bgclr"
                                      />
                                    </div>
                                  </Col>
                                  <Col xl={6}>
                                    <div className="field">
                                      <label htmlFor="month" className="block  mb-2">
                                        Start Month
                                      </label>
                                      <Dropdown
                                        id="month"
                                        value={newEducation.month}
                                        onChange={(e) => setNewEducation({ ...newEducation, month: e.value })}
                                        options={months}
                                        placeholder="Select Month"
                                        className="w-full bgclr"
                                      />
                                    </div>
                                  </Col>
                                </Row>

                                <Row className="mt-2">
                                  {/* End Date */}
                                  <Col xl={6}>
                                    <div className="field">
                                      <label htmlFor="endYear" className="block">
                                        End Year
                                      </label>
                                      <Dropdown
                                        id="endYear"
                                        value={newEducation.endYear}
                                        onChange={(e) => setNewEducation({ ...newEducation, endYear: e.value })}
                                        options={years}
                                        placeholder="Select Year"
                                        className="w-full bgclr"
                                      />
                                    </div>
                                  </Col>
                                  <Col xl={6}>
                                    <div className="field">
                                      <label htmlFor="endMonth" className="block">
                                        End Month
                                      </label>
                                      <Dropdown
                                        id="endMonth"
                                        value={newEducation.endMonth}
                                        onChange={(e) => setNewEducation({ ...newEducation, endMonth: e.value })}
                                        options={months}
                                        placeholder="Select Month"
                                        className="w-full bgclr"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-end mt-2">
                                      <Button color="primary btn-main mr-2" onClick={handleSave1}>
                                        Ok
                                      </Button>

                                    </div>
                                  </Col>
                                </Row>

                              </Dialog>
                            </Col>
                          </Row>


                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <div className="card p-4">
                      <Row className="d-flex justify-content-between">
                        <Col lg={12}>
                          <div className="d-flex mb-2">
                            <div>
                              <i className="pi pi-file me-2 diaicon"></i>
                            </div>
                            <h4 className="pre-txthead">Documents</h4>
                          </div>

                          <Row className="mt-3">
                            <Col xl={12}>
                              {/* <h5>Added Documents:</h5> */}
                              <DataTable value={documents} rows={5} className="p-datatable-gridlines"
                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                                <Column field="selectedDocument" header="Type" />
                                <Column field="subject" header="Subject" />
                                <Column field="file" header="Attachment" body={(rowData) => rowData.file ? rowData.file.name : 'No file'} />
                              </DataTable>

                              <div className="block d-flex justify-content-end align-items-center">
                                <a color="primary" className="anchr-title  mt-3" onClick={openAddDocumentDialog}>
                                  <i className="pi pi-plus me-1"></i> Add More
                                </a>
                              </div>
                            </Col>
                          </Row>

                          <Dialog
                            header="Add Document"
                            visible={displayDialog}
                            onHide={closeAddDocumentDialog}
                            style={{ width: "30vw" }}
                          >
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="type" className="block mb-2">
                                  Type
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Dropdown
  options={documentTypes.map(doc => ({
    label: doc.value,
    value: doc.value,
    id: doc.id
  }))}
  optionLabel="label"
  placeholder="Select a Document"
  value={documentvalu.selectedDocument}
  onChange={(e) => handleInputChange1("selectedDocument", e.value)}
  className="w-full bgclr"
/>
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="subject" className="block mb-2">
                                  Subject
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  id="subject"
                                  value={documentvalu.subject}
                                  onChange={(e) => handleInputChange1("subject", e.target.value)}
                                  className="w-full"
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="attachment" className="block mb-2">
                                  Attachment
                                </label>
                              </Col>
                              <Col xl={9}>
                                <FileUpload
                                  mode="basic"
                                  name="demo"
                                  url="/api/upload"
                                  accept="application/pdf"
                                  maxFileSize={1000000}
                                  onSelect={customBase64Uploader2} // Use customBase64Uploader2 to handle file selection
                                  chooseLabel="Choose File"
                                />
                                {documentvalu.file && <p>Selected: {documentvalu.file.name}</p>}
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12}>
                                <div className="d-flex justify-content-end mt-2">
                                  <Button color="primary btn-main mr-2" onClick={handleSavedocument}>
                                    Ok
                                  </Button>
                                  <Button
                                    color="btn btn-primary cancel-outlinebtn"
                                    onClick={closeAddDocumentDialog}
                                  >
                                    <i className="pi pi-times me-1"></i>
                                    Cancel
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </Dialog>


                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <div className="d-flex justify-content-between mt-4">
                  {/* <button type="button" onClick={popupHandleSubmit} class="btn btn-primary btn-main">Submit</button> */}
                  <button type="submit" className="btn btn-primary btn-main" onClick={handleSubmit(onFormSubmit)}>Preview</button>
                </div>
              </div>
              {/* view end */}
            </Container>
            // </div>  
          }

          {/* preview start */}
          <Row>
            <Col lg={12}>
              <div>
                <Dialog
                  className="details-dialog"
                  header="Review Your Details"
                  visible={showDialog}
                  onHide={handleCloseDialog}
                  breakpoints={{ '960px': '75vw' }}
                  style={{ width: '60vw' }}
                >
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="">
                              <span className="profile-icon">
                                <i className="pi pi-user"></i>
                              </span>
                              <h4 className="pre-txthead me-2">{submittedData.fullname || 'Not Provided'}</h4>
                              <p>{submittedData.jobtitle ? `${submittedData.jobtitle} at ${submittedData.company || 'Not Provided'}` : 'Not Provided'}</p>
                              <p>
  <i className="pi pi-map-marker me-1"></i>
  {
    typeof submittedData?.address === "string"
      ? submittedData.address.split(',').map(part => part.trim()).filter(Boolean).join(', ')
      : Array.isArray(submittedData?.address)
        ? submittedData.address.filter(Boolean).join(', ')
        : 'Not Provided'
  }
</p>
                              <div className="d-flex">
                                <p className="me-5">Status: {submittedData?.status || 'Not Provided'}</p>
                                <p>Experience: {submittedData?.totalExperience || 'Not Provided'}</p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="d-flex">
                              <div><i className="pi pi-phone me-2 diaicon"></i></div>
                              <h4 className="pre-txthead">Contact Information</h4>
                            </div>
                            <div className="d-flex mb-2">
                              <div>
                                <p className="mb-0">Primary Email</p>
                                <strong>{submittedData.email || 'Not Provided'}</strong>
                              </div>
                            </div>
                            <div className="d-flex mb-2">
                              <div>
                                <p className="mb-0">Secondary Email</p>
                                <strong>{getValues("Email2") || 'Not Provided'}</strong>
                              </div>
                            </div>
                            <div className="d-flex mb-2">
                              <div>
                                <p className="mb-0">Primary Phone</p>
                                <strong>{submittedData.phone || 'Not Provided'}</strong>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="d-flex">
                              <div><i className="pi pi-star me-2 diaicon"></i></div>
                              <h4 className="pre-txthead">Skills</h4>
                            </div>
                            <div className="mb-2">
                              <div className="mb-1"><strong>Primary Skills</strong></div>
                              <div>
                                {submittedData.primarySkills?.length > 0 ? (
                                  submittedData.primarySkills.map((skill, index) => (
                                    <Button key={index} className="skillbtn me-2">
                                      {primarySkillsvalu.find(item => item.skill_id === skill)?.skill_name || skill}
                                    </Button>
                                  ))
                                ) : <p>No primary skills selected</p>}
                              </div>
                            </div>
                            <div className="mb-2">
                              <div className="mb-1"><strong>Secondary Skills</strong></div>
                              <div>
                                {submittedData.secondarySkills?.length > 0 ? (
                                  submittedData.secondarySkills.map((skill, index) => (
                                    <Button key={index} className="skillbtn me-2">
                                      {secondarySkillsval.find(item => item.skill_id === skill)?.skill_name || skill}
                                    </Button>
                                  ))
                                ) : <p>No secondary skills selected</p>}
                              </div>
                            </div>
                            <div className="mb-2">
                              <div className="mb-1"><strong>Other Skills</strong></div>
                              <div>
                                {submittedData.otherSkills?.length > 0 ? (
                                  submittedData.otherSkills.map((skill, index) => (
                                    <Button key={index} className="skillbtn me-2">
                                      {otherSkillsval.find(item => item.skill_id === skill)?.skill_name || skill}
                                    </Button>
                                  ))
                                ) : <p>No other skills selected</p>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="d-flex">
                              <div><i className="pi pi-book me-2 diaicon"></i></div>
                              <h4 className="pre-txthead">Experience</h4>
                            </div>
                            {submittedData.workExperiences?.length > 0 ? (
                              submittedData.workExperiences.map((exp, index) => (
                                <div key={index} className="mb-2 d-flex">
                                  <div><i className="pi pi-user me-2"></i></div>
                                  <div className="mb-1">
                                    <strong>{exp.jobTitle || 'Not Provided'}</strong>
                                    <p className="mb-0">{exp.company || 'Not Provided'}</p>
                                    <div>
                                      <small className="fs13">
                                        {exp.fromDate && moment(exp.fromDate, 'YYYY-MM-DD', true).isValid()
              ? moment(exp.fromDate).format('YYYY-MM-DD')
              : (typeof exp.fromDate === 'string' && exp.fromDate.trim() !== '' ? exp.fromDate : 'Not Provided')
            }
            {" - "}
            {/* End Date */}
            {exp.toDate && (
              // If toDate is a valid date, format it
              moment(exp.toDate, 'YYYY-MM-DD', true).isValid()
                ? moment(exp.toDate).format('YYYY-MM-DD')
                // If toDate is a string like "Till Date" or "Present", show today's date
                : (typeof exp.toDate === 'string' && /till date|present/i.test(exp.toDate.trim())
                    ? moment().format('YYYY-MM-DD')
                    : exp.toDate)
            )}
            {!exp.toDate && 'Present'}
                                      </small>
                                    </div>
                                    <a className="fs13">{exp.website || 'Not Provided'}</a>
                                  </div>
                                </div>
                              ))
                            ) : <p>No work experience added</p>}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="d-flex">
                              <div><i className="pi pi-graduation-cap me-2 diaicon"></i></div>
                              <h4 className="pre-txthead">Education</h4>
                            </div>
                            {submittedData.educationDetails?.length > 0 ? (
                              submittedData.educationDetails.map((edu, index) => (
                                <div key={index} className="mb-2 d-flex">
                                  <div><i className="pi pi-user me-2"></i></div>
                                  <div className="mb-1">
                                    <strong>{edu.degree || 'Not Provided'}</strong>
                                    <p className="mb-0">{edu.institution || 'Not Provided'}</p>
                                    <div className="d-flex align-items-center">
                                      <div>
                                        <small className="fs13 me-2">{edu.year || 'Not Provided'}</small>
                                      </div>
                                      <small className="fs13">Grade: {edu.grade || 'Not Provided'}</small>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : <p>No education details added</p>}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="card p-4">
                        <Row className="d-flex justify-content-between">
                          <Col lg={12}>
                            <div className="d-flex">
                              <div><i className="pi pi-file me-2 diaicon"></i></div>
                              <h4 className="pre-txthead">Documents</h4>
                            </div>
                            {submittedData.documents?.length > 0 ? (
                              submittedData.documents.map((doc, index) => (
                                <div key={index}>
                                  <p className="mb-0"><strong>{doc.selectedDocument || 'Not Provided'}</strong></p>
                                  <p>{doc.file?.name || 'No file'}</p>
                                </div>
                              ))
                            ) : <p>No documents added</p>}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-between mt-4">
                    <button type="button" onClick={popupHandleSubmit} className="btn btn-primary btn-main">Submit</button>
                  </div>
                </Dialog>
              </div>
            </Col>
          </Row>
          {/* preview end */}

        </Container>
      </div>
      <footer className="footer footer-back detailsformfooter">
        <Container fluid={true}>
          <Row className="d-flex">
            <Col lg={6} md={6} xs={12}>
              <p className="d-flex justify-content-start mb-0"> &copy; 2025 Bharat ATS. All rights reserved.</p>
            </Col>
            <Col lg={6} md={6} xs={12}>
              <div className="d-flex justify-content-start justify-content-md-end">
                {/* <p className="me-3 mb-0"></p> */}
                <a
                  href="#"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="me-3"
                >
                  Privacy Policy
                </a>
                {/* <p className="me-3 mb-0">Terms of Service</p> */}
                {/* <p className="mb-0">Contact</p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <style>
        {`
  .loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
  .file-upload-input.p-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`}
      </style>
    </React.Fragment>
  );
};



export default CandidateForm;
